/** Shopper texts of the page-builder sections v2 (ST-10, docs/PRD-storefront-themes.md §5.2). */
export const shopSections = {
    slides: "Highlights",
    dealEnds: "Ends in",
    shopNow: "Shop now",
    lookbook: "Shop the look",
    viewProduct: "View {{name}}",
    logos: "As seen in",
    bundle: "Buy together",
    bundleTotal: "Total for all {{n}}",
    bundleOut: "One of these is out of stock right now.",
    playVideo: "Play video: {{title}}",
    video: "Video",
    yes: "Yes",
    no: "No",
    feature: "Feature",
    step: "Step {{n}}",
    recentlyViewed: "Recently viewed",
    menuAdd: "View",
    // ST-11 (A7–A9)
    storeLocator: "Visit our shops",
    hours: "Opening hours",
    call: "Call {{phone}}",
    directions: "Directions",
    orderAgain: "Order again",
    orderAgainIntro: "From your recent orders, at today's prices.",
    orderAgainAll: "Add all to cart",
    orderAgainAdding: "Adding…",
    orderAgainAdded: "{{n}} items added to your cart.",
    orderAgainSkipped: "{{n}} out of stock, not added.",
    orderAgainFailed: "Could not add them. Please try again.",
    orderAgainQty: "{{qty}} × {{price}}",
    outOfStock: "Out of stock",
    fewLeft: "Few left",
    sold: "{{n}}+ sold in the last 30 days",
    soldShort: "{{n}}+ sold",
    ourShops: "Our shops",
    productCount_one: "{{n}} product",
    productCount_other: "{{n}} products",
};
//# sourceMappingURL=shop-sections.js.map